/** Material UI Packages. */
import { Typography } from '@mui/material';
import { GridActionsCellItem } from '@mui/x-data-grid-pro';

/** Material UI Icons. */
import VisibilityIcon from '@mui/icons-material/Visibility';

/** Internal Components. */
import { customized_style } from 'shared/config/Styles';
import { formatOperationDateTime } from 'shared/lib/dateFormatter';

const userActivityCols = (handleDetailClick) => [
    {
        field: 'id',
        headerName: 'ID',
        headerAlign: 'center',
        align: 'center',
        flex: 0.2,
        hide: true,
        renderCell: (params) => <Typography sx={customized_style.itemDatagrid_Typography}>{params.value}</Typography>,
    },
    {
        field: 'execution_date',
        headerName: 'Execution Date',
        headerAlign: 'center',
        align: 'center',
        flex: 1.1,
        renderCell: (params) => {
            // 어느 나라에서 감사 화면을 열어도 같은 시각으로 읽히도록 근무지(LA) 기준으로 보여준다.
            const formatDate = (dateString) => formatOperationDateTime(dateString, 'MM/DD/YYYY @HH:mm');

            return <Typography sx={customized_style.itemDatagrid_Typography}>{formatDate(params.value)}</Typography>;
        },
    },
    {
        field: 'message',
        headerName: 'Channel',
        headerAlign: 'center',
        align: 'center',
        flex: 0.7,
        renderCell: (params) => (
            <Typography sx={customized_style.itemDatagrid_Typography}>{params.value?.toUpperCase()}</Typography>
        ),
    },
    {
        field: 'method',
        headerName: 'Action',
        headerAlign: 'center',
        align: 'center',
        flex: 0.7,
        renderCell: (params) => <Typography sx={customized_style.itemDatagrid_Typography}>{params.value}</Typography>,
    },
    {
        field: 'tab',
        headerName: 'Shipment Type',
        headerAlign: 'center',
        align: 'center',
        flex: 1,
        renderCell: (params) => {
            const shipmentTypes = ['OCEAN IMPORT', 'OCEAN EXPORT', 'AIR IMPORT', 'AIR EXPORT', 'FTL/LTL'];
            const displayValue =
                params.value != null && params.value !== ''
                    ? shipmentTypes[params.value] || params.value?.toUpperCase() || '-'
                    : '-';

            return <Typography sx={customized_style.itemDatagrid_Typography}>{displayValue}</Typography>;
        },
    },
    {
        field: 'format_',
        headerName: 'Scope',
        headerAlign: 'center',
        align: 'center',
        flex: 0.7,
        renderCell: (params) => (
            <Typography sx={customized_style.itemDatagrid_Typography}>{params.value?.toUpperCase()}</Typography>
        ),
    },
    {
        field: 'component',
        headerName: 'Component',
        headerAlign: 'center',
        align: 'center',
        flex: 1.2,
        renderCell: (params) => (
            <Typography sx={customized_style.itemDatagrid_Typography}>{params.value?.toUpperCase()}</Typography>
        ),
    },
    {
        field: 'data',
        headerName: 'Input Data',
        headerAlign: 'center',
        align: 'center',
        flex: 2.1,
        hide: true,
        valueGetter: (params) => {
            if (params === null || params === undefined) return '';
            if (typeof params === 'object') {
                return JSON.stringify(params);
            }
            return String(params);
        },

        renderCell: (params) => (
            <Typography
                sx={{ ...customized_style.itemDatagrid_Typography, whiteSpace: 'normal', wordBreak: 'break-word' }}
            >
                {JSON.stringify(params.value)}
            </Typography>
        ),
    },
    {
        field: 'username',
        headerName: 'Executed By',
        headerAlign: 'center',
        align: 'center',
        flex: 1,
        renderCell: (params) => <Typography sx={customized_style.itemDatagrid_Typography}>{params.value}</Typography>,
    },
    {
        field: 'actions',
        headerName: '',
        flex: 0.3,
        editable: false,
        align: 'center',
        headerAlign: 'center',
        type: 'actions',
        getActions: (params) => {
            return [
                <GridActionsCellItem
                    icon={<VisibilityIcon sx={{ color: 'rgba(0, 0, 0, 0.54)' }} />}
                    label="Delete"
                    onClick={() => handleDetailClick(params.id)}
                    color="inherit"
                />,
            ];
        },
    },
];

const systemActivityCols = (handleDetailClick) => [
    {
        field: 'id',
        headerName: 'ID',
        headerAlign: 'center',
        align: 'center',
        flex: 0.2,
        hide: true,
        renderCell: (params) => <Typography sx={customized_style.itemDatagrid_Typography}>{params.value}</Typography>,
    },
    {
        field: 'execution_date',
        headerName: 'Execution Date',
        headerAlign: 'center',
        align: 'center',
        flex: 1,
        renderCell: (params) => {
            // 어느 나라에서 감사 화면을 열어도 같은 시각으로 읽히도록 근무지(LA) 기준으로 보여준다.
            const formatDate = (dateString) => formatOperationDateTime(dateString, 'MM/DD/YYYY @HH:mm');

            return <Typography sx={customized_style.itemDatagrid_Typography}>{formatDate(params.value)}</Typography>;
        },
    },
    {
        field: 'method',
        headerName: 'Action',
        headerAlign: 'center',
        align: 'center',
        flex: 0.7,
        renderCell: (params) => <Typography sx={customized_style.itemDatagrid_Typography}>{params.value}</Typography>,
    },
    {
        field: 'tab',
        headerName: 'Shipment Type',
        headerAlign: 'center',
        align: 'center',
        flex: 1,
        renderCell: (params) => {
            const shipmentTypes = ['OCEAN IMPORT', 'OCEAN EXPORT', 'AIR IMPORT', 'AIR EXPORT', 'FTL/LTL'];
            const displayValue =
                params.value != null && params.value !== ''
                    ? shipmentTypes[params.value] || params.value?.toUpperCase() || '-'
                    : '-';

            return <Typography sx={customized_style.itemDatagrid_Typography}>{displayValue}</Typography>;
        },
    },
    {
        field: 'format_',
        headerName: 'Scope',
        headerAlign: 'center',
        align: 'center',
        flex: 0.7,
        renderCell: (params) => (
            <Typography sx={customized_style.itemDatagrid_Typography}>{params.value?.toUpperCase()}</Typography>
        ),
    },
    {
        field: 'component',
        headerName: 'Component',
        headerAlign: 'center',
        align: 'center',
        flex: 1.2,
        renderCell: (params) => (
            <Typography sx={customized_style.itemDatagrid_Typography}>{params.value?.toUpperCase()}</Typography>
        ),
    },
    {
        field: 'error',
        headerName: 'Input Data',
        headerAlign: 'center',
        align: 'center',
        flex: 2.2,
        hide: true,
        valueGetter: (params) => {
            if (params === null || params === undefined) return '';
            if (typeof params === 'object') {
                return JSON.stringify(params);
            }
            return String(params);
        },

        renderCell: (params) => (
            <Typography
                sx={{ ...customized_style.itemDatagrid_Typography, whiteSpace: 'normal', wordBreak: 'break-word' }}
            >
                {JSON.stringify(params.value)}
            </Typography>
        ),
    },
    {
        field: 'username',
        headerName: 'Executed By',
        headerAlign: 'center',
        align: 'center',
        flex: 1,
        renderCell: (params) => <Typography sx={customized_style.itemDatagrid_Typography}>{params.value}</Typography>,
    },
    {
        field: 'actions',
        headerName: '',
        flex: 0.3,
        editable: false,
        align: 'center',
        headerAlign: 'center',
        type: 'actions',
        getActions: (params) => {
            return [
                <GridActionsCellItem
                    icon={<VisibilityIcon sx={{ color: 'rgba(0, 0, 0, 0.54)' }} />}
                    label="Delete"
                    onClick={() => handleDetailClick(params.id)}
                    color="inherit"
                />,
            ];
        },
    },
];
export { userActivityCols, systemActivityCols };
